//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            dialogVisible: false,
            tableLoading: false,
            tableData: [],
        };
    },

    methods: {
        setResults (results) {
            this.tableData = results;
        },

        show () {
            this.dialogVisible = true;
        },

        hide () {
            this.dialogVisible = false;
        }
    }
};
